import { ConnectionDisplayName } from '@app/modules/social-export/components/ConnectionDisplayName';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useSocialExportGetConnectionById } from '@mi-front/api-v2';
import { Avatar, Stack, Typography } from '@mui/material';

interface UploadCardProfileContextProps {
  platform: SocialPlatform;
  connectionId: string | undefined;
}

/**
 * Top-bar context: platform icon + "Platform • [avatar] Profile" when a connection is available.
 */
export function UploadCardProfileContext({
  platform,
  connectionId,
}: UploadCardProfileContextProps) {
  const connectionQuery = useSocialExportGetConnectionById(connectionId ?? '', {
    query: { enabled: !!connectionId },
  });

  const connection = connectionQuery.data;
  const profilePhoto = connection?.profile.photo;
  const avatarInitial = connection
    ? (connection.name || connection.profile.displayName).charAt(0)
    : null;

  return (
    <Stack direction="row" alignItems="center" gap={1} minWidth={0}>
      {platform.Icon({ sx: { fontSize: 24 }, colored: true })}
      <Typography variant="subtitle2" color="text.secondary" noWrap>
        {platform.name}
      </Typography>
      {connection ? (
        <>
          <Typography variant="subtitle2" color="text.secondary">
            •
          </Typography>
          <Avatar
            src={profilePhoto || undefined}
            sx={{ width: 20, height: 20, typography: 'caption' }}
          >
            {!profilePhoto ? avatarInitial : null}
          </Avatar>
          <ConnectionDisplayName
            connection={connection}
            variant="subtitle2"
            color="text.secondary"
            noWrap
            component="span"
          />
        </>
      ) : null}
    </Stack>
  );
}
